import { type JsonLd } from 'json-ld-types';
import { nanoid } from 'nanoid';

import { type DeepPartial } from '@canvas/utils';

export const mockContext = {
  '@vocab': 'https://www.w3.org/ns/activitystreams#',
  atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
  schema: 'http://schema.org/',
} as const;

export const mockDataName = 'Sending It';
const mockPreviewName = 'Sending It Preview';

export const mockDataCardResponse = (url = mockUrl()) =>
  ({
    meta: {
      access: 'granted',
      visibility: 'restricted',
      tenantId: 'a436116f-02ce-4520-8fbb-7301462a1674',
    },
    data: {
      '@context': mockContext,
      '@type': 'Application',
      url,
      name: mockDataName,
      preview: { '@type': 'Link', href: url },
      // @ts-expect-error - not mocking JSON-LD properties
      icon: {
        url: 'http://icon.url',
      },
    },
  }) satisfies JsonLd.Response;

export const mockDataCardResponseWithNoName = (url = mockUrl()): JsonLd.Response => ({
  meta: {
    access: 'granted',
    visibility: 'restricted',
    tenantId: 'a436116f-02ce-4520-8fbb-7301462a1674',
  },
  data: {
    name: undefined,
    '@context': mockContext,
    '@type': 'Application',
    url,
    preview: { '@type': 'Link', href: url },
    // @ts-expect-error - not mocking JSON-LD properties
    icon: {
      url: 'http://icon.url',
    },
  },
});

export const mockPreviewCardResponse = (
  url = mockUrl(),
  provider = 'link-provider',
): JsonLd.Response => ({
  meta: {
    access: 'granted',
    visibility: 'restricted',
    key: provider,
    tenantId: 'a436116f-02ce-4520-8fbb-7301462a1674',
  },
  data: {
    '@context': mockContext,
    '@type': 'Application',
    url,
    name: mockPreviewName,
    image: { '@type': 'Link', href: url },
    preview: { '@type': 'Link', href: url },
  },
});

export const mockUnauthedDataCardResponse = (url = mockUrl()): JsonLd.Response => ({
  meta: { access: 'unauthorized', visibility: 'restricted' },
  data: mockDataCardResponse(url).data,
});

export const mockUrl = () => `https://sending-it.com/${nanoid()}`;

export const mockResponse = (options: DeepPartial<JsonLd.Response>) => {
  const base = mockDataCardResponse(undefined);

  return {
    ...base,
    ...options,
    data: {
      ...base.data,
      ...options.data,
    } as JsonLd.Response['data'],
    meta: {
      ...base.meta,
      ...options.meta,
    },
  } satisfies JsonLd.Response;
};
